import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import i18n from '@/lib/i18n/i18n';

const { t } = i18n;

const getProjectHeaderFormValidationSchema = (allowForEmptyName: boolean) =>
  z.object({
    name: allowForEmptyName
      ? z.string().optional().nullable()
      : z.string().min(1, t('projects:projectOverview.noEmptyName')),
    status: z
      .enum(['active', 'on_hold', 'stuck', 'done'])
      .optional()
      .nullable(),
    createdFor: z
      .object({ value: z.string(), label: z.string() })
      .optional()
      .nullable(),
    type: z
      .object({ value: z.string(), label: z.string() })
      .optional()
      .nullable(),
    owner: z
      .object({ value: z.string(), label: z.string() })
      .optional()
      .nullable(),
    timeframe: z
      .object({ timeframeStart: z.string(), timeframeEnd: z.string() })
      .optional()
      .nullable(),
  });

export type ProjectHeaderForm = z.output<
  ReturnType<typeof getProjectHeaderFormValidationSchema>
>;

export const useProjectHeaderForm = (
  defaultValues: ProjectHeaderForm,
  allowForEmptyName = false,
) =>
  useForm<ProjectHeaderForm>({
    mode: 'all',
    reValidateMode: 'onBlur',
    resolver: zodResolver(
      getProjectHeaderFormValidationSchema(allowForEmptyName),
    ),
    defaultValues,
  });
